import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  // Store an item with a generic type
  public storeItem<T>(key: string, value: T, callback?: () => void): void {
    const item = typeof value === 'string' ? value : JSON.stringify(value);
    localStorage.setItem(key, item);
    callback?.();
  }

  // Store an item in sessionStorage with a generic type
  public storeItemInSession<T>(key: string, value: T): void {
    const item = typeof value === 'string' ? value : JSON.stringify(value);
    sessionStorage.setItem(key, item);
  }

  // Read an item with a generic return type
  // Read an item with a generic return type
  public readItem<T>(key: string): T | null {
    const result = localStorage.getItem(key);

    if (!result) {
      return null;
    }

    // Keys that should be returned as plain strings without JSON parsing
    const plainStringKeys = ['auth_credentials', 'returnUrl'];

    if (plainStringKeys.includes(key)) {
      return result as T;
    }

    // For other keys, try to parse as JSON
    try {
      return JSON.parse(result) as T;
    } catch {
      // If JSON.parse fails, return as plain string
      return result as T;
    }
  }
  // Remove an item from localStorage
  public removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  // Clear the localStorage
  public clearStorage(): void {
    localStorage.clear();
  }
}
